import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { RoundProgressModule } from 'angular-svg-round-progressbar';

@Component({
    selector: 'app-arc-percentage-chart',
    templateUrl: './arc-percentage-chart.component.html',
    styleUrls: ['./arc-percentage-chart.component.scss']
})
export class ArcPercentageChartComponent implements OnInit {
    @Input() percentage = 0;
    @Input() label = 'none';
    @Input() max = 100;
    @Input() radius = 100;
    @Input() stroke = 22;
    @Input() semicircle = 'true';
    @Input() class = '';
    @Input() color = '#0E6461';
    constructor() {}

    getNum() {
        return parseInt(this.percentage?.toString() ?? '0');
    }
    ngOnInit() {}
}
